import { useState, useEffect } from "react";
import { Button } from "../../../../components/ui/button";

export const Frame2ByAnima = ({ onLinkClick }: { onLinkClick: (id: string) => void }): JSX.Element => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { name: "Features", id: "features" },
    { name: "Benefits", id: "benefits" },
    { name: "Activities", id: "activities" },
    { name: "Review", id: "reviews" },
    { name: "Faq's", id: "faqs" }
  ];

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Effect to handle body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "auto";
  }, [isMobileMenuOpen]);

  // Handle scroll to section
  const handleScrollTo = (id: string) => {
    onLinkClick(id);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full overflow-x-hidden transition-all duration-500 ease-in-out max-w-full ${
        isMobileMenuOpen ? "h-screen bg-white" : "h-[64px]"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-10 py-2 h-full bg-white backdrop-blur-[20px] shadow-md max-w-full overflow-x-hidden">
        {/* Logo */}
        <a href="#" aria-label="Homepage">
          <div>
            <img
              src="/assets/Logo.png"
              alt="Company logo"
              className="h-12 w-full object-contain max-w-full"
            />
          </div>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item, index) => (
            <button
              key={index}
              onClick={() => handleScrollTo(item.id)}
              className="font-['Plus_Jakarta_Sans', Helvetica] font-semibold text-[#E53E5F] text-base hover:text-[#F5A93E] transition-colors"
            >
              {item.name}
            </button>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button
            className="inline-flex items-center justify-center rounded-md h-9 w-9 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring hover:bg-accent hover:text-accent-foreground"
            onClick={toggleMobileMenu}
            aria-haspopup="dialog"
            aria-expanded={isMobileMenuOpen ? "true" : "false"}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="lucide lucide-menu h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="4" x2="20" y1="6" y2="6" />
              <line x1="4" x2="20" y1="12" y2="12" />
              <line x1="4" x2="20" y1="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Get Yours Button (Desktop Only) */}
        <button
          onClick={() => {
            handleScrollTo("pricing");
          }}
          className="hidden md:inline-flex justify-center items-center whitespace-nowrap bg-[#E53E5F] hover:bg-[#F5A93E] text-white px-6 py-3 rounded-full shadow-[inset_0px_9px_19px_#a870cc33] font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-base transition-opacity"
        >
          Get Yours
        </button>
      </nav>

      {/* Mobile Menu Overlay (Small screens only) */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 w-full overflow-x-hidden bg-white z-50 flex justify-center items-center flex-col gap-6 py-8 transition-all duration-300 md:hidden max-w-full">
          {/* Close Button */}
          <button
            className="absolute top-6 right-6 text-3xl text-[#E53E5F] hover:text-[#F5A93E] font-bold"
            onClick={toggleMobileMenu}
          >
            X
          </button>

          {/* Mobile Nav Items */}
          <div className="flex flex-col items-center gap-6">
            {navItems.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  handleScrollTo(item.id);
                  setIsMobileMenuOpen(false);
                }}
                className="font-['Plus_Jakarta_Sans', Helvetica] font-semibold text-[#E53E5F] text-xl hover:text-[#F5A93E] transition-colors opacity-0 transform translate-y-10 animate-slideIn"
                style={{
                  animationDelay: `${index * 0.2}s`
                }}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
